import React from 'react';
import { IconChevronsUp } from '@tabler/icons';
import { ActionIcon, createStyles } from '@mantine/core';

interface FabProps {
  pageRoute?: string;
}

const useStyles = createStyles((theme) => ({
  fab: {
    position: 'fixed',
    bottom: '80px',
    right: '50px; ',
    cursor: 'pointer',
    zIndex: 100,

    translate: '-4px 4px',
    boxShadow: '-4px 4px 0 goldenrod',
    borderRadius: '10px',
    '&:hover': {
      boxShadow: '-6px 6px 0 goldenrod',
      translate: '-2px 2px',
      transitionDuration: '0.1s',
      '&:active': {
        boxShadow: '0 0 0 goldenrod',
        translate: '-9px 9px',
      },
    },
    marginRight: '10px',
    [theme.fn.largerThan('sm')]: {
      marginInline: '100px',
    },
  },
}));

export default function Fab({ pageRoute }: FabProps) {
  const { classes } = useStyles();
  const [fabHidden, toggleFabHidden] = React.useState(true);

  const onScroll = (e: any) => {
    toggleFabHidden(e.target.documentElement.scrollTop < 100);
  };

  React.useEffect(() => {
    window.addEventListener('scroll', onScroll);
  }, []);

  return (
    <a href={`${pageRoute}#top`} className={classes.fab} hidden={fabHidden}>
      <ActionIcon color="primary" size="xl" radius="md" variant="filled">
        <IconChevronsUp size="24" />
      </ActionIcon>
    </a>
  );
}
